module.exports = __webpack_public_path__ + "img/area_22.775bde0b.svg";